import React, { lazy, Suspense } from 'react';
import cn from 'classnames';
import Container from 'components/UI/Container';
import Title from 'components/UI/Title';
import { useStateModal } from 'utils/hooks';
import { useTrans } from 'utils/localisation';
import DesktopContent from './DesktopContent';
import MobileContent from './MobileContent';
import { withErrorBoundary } from 'components/ErrorBoundary';

import * as styles from './TechnologiesGrid.module.scss';

const RequestConsultation = lazy(() => import('components/Modals/RequestConsultation'));

function TechnologiesGrid({ title, tabsContent }) {
  const t = useTrans(['common']);
  const { modalState, showModal, hideModal } = useStateModal();

  return (
    <>
      <Container
        className={cn(styles.container, tabsContent.length > 1 && styles.containerWithTabs)}
        id="expertise"
      >
        <div className={styles.wrapper}>
          <Title tag="h2" className={styles.title}>
            {title}
          </Title>
          <DesktopContent tabsContent={tabsContent} showModal={showModal} />
          <MobileContent tabsContent={tabsContent} showModal={showModal} />
        </div>
      </Container>
      <Suspense fallback={null}>
        <RequestConsultation
          title={t('requestServices')}
          isOpen={modalState.isOpen}
          closeModalCallback={hideModal}
          animation="show"
          id="technologies-block"
          formName="technologies-block"
        />
      </Suspense>
    </>
  );
}

TechnologiesGrid.displayName = 'TechnologiesGrid';

export default withErrorBoundary(TechnologiesGrid);
